import React from "react";
import "./App.css";
import Header from "./components/Header/Header";
import Main from "./components/Main";

function App() {
  return (
    <div className="App">
      <Header />
      <div className="inputContainers">
        <Main />
      </div>
    </div>
  );
}

export default App;
